import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-move-arrow-icon',
  templateUrl: './move-arrow-icon.component.html',
  styleUrls: ['./move-arrow-icon.component.scss']
})
export class MoveArrowIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
